export default __webpack_public_path__ + "static/media/IFSEC-International-2017-1.26b0b396.jpg";